import { Chart } from "chart.js";

let noDataText = 'Aucune donnée';

/**
 * Set the text drawn by the noDataPlugin (called on app language change).
 */
export function setNoDataText(text: string): void {
    noDataText = text;
}

const noDataPlugin = {
    id: 'noDataPlugin',
    beforeDraw: (chart: Chart) => {
        const datasets = chart.data.datasets;
        const hasData = datasets.some((dataset) => dataset.data.length > 0);

        if (!hasData) {
            const ctx = chart.ctx;
            const width = chart.width;
            const height = chart.height;

            ctx.save();
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.font = '16px Arial';
            ctx.fillText(noDataText, width / 2, height / 2);
            ctx.restore();
        }
    }
};

export default noDataPlugin;